import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";

import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { LinkedInPostSchema } from "../../../../schemas";

interface PostInputProps {
  setPostId: (postId: string) => void;
}

export default function PostFormField({ setPostId }: PostInputProps) {
  const isDesktop = useTwBreakpoint("lg");

  const {
    register,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: { postUrl: "" },
    resolver: valibotResolver(LinkedInPostSchema),
  });

  function onPaste(text: string) {
    const trimmedText = text.trim();
    if (trimmedText) {
      const postIdMatch = trimmedText.match(/\d{19}/);

      if (postIdMatch) {
        setPostId(postIdMatch[0]);
      } else {
        setError("postUrl", { message: "Invalid LinkedIn post URL format" });
      }
    }
  }

  return (
    <FormField
      label="Post URL"
      htmlFor="postUrl"
      error={errors?.postUrl?.message}
      hint="Find the URL by clicking the three dots (•••) at the top of the post in your LinkedIn feed"
    >
      <Input
        variant={isDesktop ? "md" : "lg"}
        id="postUrl"
        placeholder="Enter post URL here"
        {...register("postUrl")}
        onClick={(e) => e.currentTarget.select()}
        onFocus={(e) => e.target.select()}
        onPaste={(e) => onPaste(e.clipboardData.getData("text"))}
      />
    </FormField>
  );
}
